import { Component, Injector, ChangeDetectionStrategy } from '@angular/core'
import { AbstractControl, FormArray, FormGroup, Validators } from '@angular/forms'
import { MatDialog } from '@angular/material/dialog'
import { TemplateMessageObject } from '@trendbuild/trend-cloud-api'
import { AbstractComponent, Channel, ChannelService, ChannelTypeEnum, Company, ConfirmationComponent, MetadataMessage, RCSData, RCSMessageTypeEnum, Traduct, Webhook, WebhookIntegrationItemType, WebhookIntegrationItemTypeTranslate, WebhookIntegrations, WebhookIntegrationsService, WebhookRequestTypeEnum } from 'lib-trend-core'
import { v4 as uuidv4 } from 'uuid'
import { environment } from '../../../../../environments/environment'
import { buildRcsDataGroup, legacyActionToRcsData, rcsMessageType, rcsValueMirror } from '../../../rcs-message/rcs-message-form.util'
import { WebhookTestModalComponent } from '../webhook-test-modal/webhook-test-modal.component'

@Component({
    selector: 'webhook-integrations-form-component',
    templateUrl: './webhook-integrations-form.v2.component.html',
    // templateUrl: './webhook-integrations-form.component.html',
    styleUrls: ['./webhook-integrations-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WebhookIntegrationsFormComponent extends AbstractComponent {
  webhookIntegrations?: WebhookIntegrations
  selectedChannel: Channel
  templateMessage: MetadataMessage;

  isActive: boolean = false;
  curlContent: string;
  url: string
  webhookRequests: object
  webhookSelectedId: string
  showPreviewTemplate: boolean
  previewHeader: any
  translator!: Traduct

  requestsSelected: Array<object> = new Array<object>()
  channels: Array<Channel> = new Array<Channel>()

  selectedTemplate: TemplateMessageObject

  webhooks: Array<Webhook> = new Array<Webhook>()

  actionsType: string[];

  breadcrumb = [
    { href: '/integrations', label: 'integrations.breadcrumb.integrations' },
    { href: '/integrations/webhook/list', label: 'integrations.breadcrumb.webhook' },
    { label: '' },
  ]

  constructor(
    injector: Injector,
    public channelService: ChannelService,
    public webhookIntegrationsService: WebhookIntegrationsService,
    public dialog: MatDialog,
  ) {
    super(injector)
    this.createForm();
  }

  ngOnInit() {
    this.webhookIntegrations = <WebhookIntegrations>{}
    const idWebhook = this.getParam('id')
    this.isNew = !idWebhook ? true : false

    if (!this.isNew) {
      this.breadcrumb[2].label = 'Editar Webhook';
    } else {
      this.breadcrumb[2].label = 'Adicionar Webhook';
    }

    this.isActive = this.webhookIntegrations.actived;
    this.channelService.getList().subscribe({
      next: (channels) => {
        this.channels = channels.filter((channel) => channel.type !== ChannelTypeEnum.INSTAGRAM_API && channel.type !== ChannelTypeEnum.MESSENGER_API);
        if (this.isNew) {
          this.webhookIntegrations.uuid = uuidv4();
          this.webhookIntegrations.url = this.generateWebhookIntegrationsURLbyCode(this.webhookIntegrations.uuid);
          this.formGroup.get('url').setValue(this.webhookIntegrations.url);
          this.formGroup.get('company').setValue(this.getIDCurrentCompany());
          this.formGroup.get('uuid').setValue(this.webhookIntegrations.uuid);
          this.addComponent(WebhookIntegrationItemType.WHATSAPP_PHONE);
          this.addComponent(WebhookIntegrationItemType.CONTACT_NAME);
        } else {
          this.webhookIntegrationsService.getById(idWebhook).subscribe({
            next: (webhookIntegrations) => {
              this.webhookIntegrations = webhookIntegrations;
              this.populateForm();
              this.getWebhookRequests();
              this.selectedChannel = this.channels.find((c) => c._id === this.formGroup.get('channel').value);
              this.createActionTypeList();
            },
            complete: () => {
            }
          })
        }
      },
      complete: () => {
        this.selectedChannel = !this.isNew ? this.channels.find((c) => c._id === this.webhookIntegrations.channel as unknown) : this.selectedChannel
      }
    })
  }

  ngAfterViewInit(): void {
  }

  override ngOnDestroy(): void {
  }

  selectChannel(idChannel: string): void {
    const wasRcs = this.isRcsChannel();
    this.selectedChannel = this.channels.find((c) => c._id === idChannel)

    // A message or trigger action is shaped by its channel: the RCS editor on RCS, the Z-API fields
    // elsewhere. Crossing between the two leaves nothing to convert, so those actions go — the
    // confirmation shown before the switch already says the actions are deleted.
    if (wasRcs !== this.isRcsChannel()) {
      for (let index = this.items.length - 1; index >= 0; index--) {
        const type = this.items.at(index).get('type').value;
        if (type === WebhookIntegrationItemType.SEND_MESSAGE || type === WebhookIntegrationItemType.ADD_TRIGGER_MESSAGE) {
          this.items.removeAt(index);
        }
      }
    }

    this.createActionTypeList();
    if (this.selectedChannel.type === ChannelTypeEnum.CLOUD_API) {
      this.items.controls = this.items.controls.filter((item) => {
        return item.get('type').value !== WebhookIntegrationItemType.ADD_TAG &&
          item.get('type').value !== WebhookIntegrationItemType.REMOVE_TAG &&
          item.get('type').value !== WebhookIntegrationItemType.ADD_CONTACT_GROUP &&
          item.get('type').value !== WebhookIntegrationItemType.REMOVE_CONTACT_GROUP &&
          item.get('type').value !== WebhookIntegrationItemType.SEND_MESSAGE &&
          item.get('type').value !== WebhookIntegrationItemType.ADD_TEMPLATE &&
          item.get('type').value !== WebhookIntegrationItemType.CREATE_OPPORTUNITY &&
          item.get('type').value !== WebhookIntegrationItemType.TRANSFER_ATTENDANCE &&
          item.get('type').value !== WebhookIntegrationItemType.CREATE_TRACKING &&
          item.get('type').value !== WebhookIntegrationItemType.ORIGIN_LEAD
      });
      // this.addComponent(WebhookIntegrationItemType.ADD_TEMPLATE);
    } else {
      this.items.controls = this.items.controls.filter((item) => {
        return item.get('type').value !== WebhookIntegrationItemType.ADD_TEMPLATE &&
          item.get('type').value !== WebhookIntegrationItemType.CREATE_OPPORTUNITY &&
          item.get('type').value !== WebhookIntegrationItemType.TRANSFER_ATTENDANCE &&
          item.get('type').value !== WebhookIntegrationItemType.CREATE_TRACKING &&
          item.get('type').value !== WebhookIntegrationItemType.ORIGIN_LEAD
      });
    }
  }

  toggleWebhookStatus() {
    this.webhookIntegrations.actived = !this.webhookIntegrations.actived;
    if (this.isActive && !this.formGroup.valid) {
      this.validateAllFormFields(this.formGroup)
      this.isActive = false;
      return
    }
    if (this.isActive) {
      this.save();
    } else {
      this.ableDisableFields();
    }
  }

  changeChannelDialog(idChannel: string) {
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      data: this.t('integrations.webhookForm.confirmChangeChannel'),
      width: '500px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (Boolean(result) === true) {
        this.selectChannel(idChannel)
        this.alertService.success(this.t('integrations.webhookForm.successChannelChanged'));
      }
    });
  }

  async copyUrl() {
    try {
      await navigator.clipboard.writeText(this.webhookIntegrations.url)
      this.alertService.info(this.t('integrations.webhookForm.infoUrlCopied'))
    } catch (error) {
      console.error(error.message)
    }
  }

  save() {
    if (!this.formGroup.valid) {
      this.validateAllFormFields(this.formGroup)
      return
    }
    this.loading = true;
    const actions = [];
    this.items.controls.forEach((item) => {
      let action = null;
      if (item.get('type').value === WebhookIntegrationItemType.WHATSAPP_PHONE) {
        action = {
          type: "phone",
          value: item.get('value').value
        }
      } else if (item.get('type').value === WebhookIntegrationItemType.CONTACT_NAME) {
        action = {
          type: "name",
          value: item.get('value').value
        }
      } else if (item.get('type').value === WebhookIntegrationItemType.ADD_TAG) {
        action = {
          type: "addTag",
          value: item.get('value').value
        }
      } else if (item.get('type').value === WebhookIntegrationItemType.REMOVE_TAG) {
        action = {
          type: "removeTag",
          value: item.get('value').value
        }
      } else if (item.get('type').value === WebhookIntegrationItemType.ADD_CONTACT_GROUP) {
        action = {
          type: "addContactGroup",
          value: item.get('value').value
        }
      } else if (item.get('type').value === WebhookIntegrationItemType.REMOVE_CONTACT_GROUP) {
        action = {
          type: "removeContactGroup",
          value: item.get('value').value
        }
      } else if (item.get('type').value === WebhookIntegrationItemType.START_ATTENDANCE) {
        action = {
          type: "attendance",
          value: {
            department: item.get('value').value,
            user: item.get('attendent').value
          }
        }
      } else if (item.get('type').value === WebhookIntegrationItemType.CREATE_OPPORTUNITY) {
        action = {
          type: "createOpportunity",
          value: {
            funnel: item.get('funnel').value,
            stage: item.get('stage').value,
            priority: item.get('priority').value,
            user: item.get('user').value,
            product: item.get('product').value,
          }
        }
      } else if (item.get('type').value === WebhookIntegrationItemType.CLOSE_ATTENDANCE) {
        action = {
          type: "closeAttendance",
        }
      } else if (item.get('type').value === WebhookIntegrationItemType.SEND_MESSAGE && item.get('rcsData')) {
        action = {
          type: "message",
          ...this.rcsActionFields(item),
        }
      } else if (item.get('type').value === WebhookIntegrationItemType.SEND_MESSAGE) {
        action = {
          type: "message",
          typeMessage: item.get('typeMessage').value,
          value: item.get('value').value,
          caption: item.get('caption')?.value,
          title: item.get('title')?.value,
          footer: item.get('footer')?.value,
          buttonActions: item.get('buttonActions')?.value,
        }
      } else if (item.get('type').value === WebhookIntegrationItemType.ADD_TEMPLATE) {
        action = {
          type: "message",
          typeMessage: 'template',
          template: item.get('template').value,
          templateParamsHeader: item.get('templateParamsHeader').value,
          templateParamsBody: item.get('templateParamsBody').value,
          templateParamsButton: item.get('templateParamsButton').value,
          previewText: item.get('previewText').value,
        }
      } else if (item.get('type').value === WebhookIntegrationItemType.ADD_TRIGGER_MESSAGE && item.get('rcsData')) {
        action = {
          type: "triggerMessage",
          ...this.rcsActionFields(item),
          nameTriggerMessage: item.get('nameTriggerMessage').value,
          keysTriggerMessage: item.get('keysTriggerMessage').value,
          urlTriggerMessage: item.get('urlTriggerMessage').value,
          id: item.get('id').value,
        }
      } else if (item.get('type').value === WebhookIntegrationItemType.ADD_TRIGGER_MESSAGE) {
        action = {
          type: "triggerMessage",
          typeMessage: item.get('typeMessage').value,
          value: item.get('value').value,
          nameTriggerMessage: item.get('nameTriggerMessage').value,
          keysTriggerMessage: item.get('keysTriggerMessage').value,
          urlTriggerMessage: item.get('urlTriggerMessage').value,
          id: item.get('id').value,
        }
      } else if (item.get('type').value === WebhookIntegrationItemType.TRANSFER_ATTENDANCE) {
        action = {
          type: "transferAttendance",
          department: item.get('department').value,
          user: item.get('user').value,
        }
      } else if (item.get('type').value === WebhookIntegrationItemType.CREATE_TRACKING) {
        action = {
          type: "createTracking",
        }
      } else if (item.get('type').value === WebhookIntegrationItemType.ORIGIN_LEAD) {
        action = {
          type: "originLead",
          originLead: item.get('originLead').value,
        }
      }
      actions.push(action);
    });
    const webhook = <WebhookIntegrations>{
      _id: this.webhookIntegrations._id,
      uuid: this.webhookIntegrations.uuid,
      name: this.formGroup.get('name').value,
      url: this.formGroup.get('url').value,
      actived: this.isActive,
      company: <Company>{ _id: super.getIDCurrentCompany() },
      channel: <Channel>{ _id: this.selectedChannel._id },
      webhook: <Webhook>{ _id: this.webhookSelectedId },
      actions: actions,
    }

    if (!this.isNew) {
      this.webhookIntegrationsService
        .update(this.webhookIntegrations._id, webhook)
        .subscribe({
          next: () => {
            this.alertService.success();
            this.goBack();
          },
          error: (err) => {
            this.alertService.error(err.error.message);
            this.loading = false;
          },
          complete: () => this.loading = false
        })
    } else {
      this.webhookIntegrationsService.create(webhook).subscribe({
        next: () => {
          this.alertService.success();
          this.goBack();
        },
        error: (err) => {
          this.alertService.error(err.error.message);
          this.loading = false;
        },
        complete: () => this.loading = false
      })
    }
  }

  private createForm(): void {
    this.formGroup = this.formBuilder.group({
      _id: [null],
      name: [null, Validators.required],
      url: [null, Validators.required],
      channel: [null, Validators.required],
      company: [null, Validators.required],
      actived: [false, Validators.required],
      webhook: [null, Validators.required],
      uuid: [null, Validators.required],
      requestType: [WebhookRequestTypeEnum.DEFAULT, Validators.required],
      tags: [null],
      items: this.formBuilder.array([])
    });
  }

  populateForm() {
    this.formGroup.get('_id').setValue(this.webhookIntegrations._id);
    this.formGroup.get('name').setValue(this.webhookIntegrations.name);
    this.formGroup.get('url').setValue(this.webhookIntegrations.url);
    this.formGroup.get('uuid').setValue(this.webhookIntegrations.uuid);
    this.formGroup.get('actived').setValue(this.webhookIntegrations.actived);
    this.formGroup.get('channel').setValue(this.webhookIntegrations.channel._id);
    this.formGroup.get('webhook').setValue(this.webhookIntegrations.webhook);
    this.formGroup.get('company').setValue(this.webhookIntegrations.company);
    this.webhookSelectedId = this.webhookIntegrations.webhook as unknown as string;
    this.isActive = this.webhookIntegrations.actived;
    this.webhookIntegrations.actions.forEach((action: any) => {
      let item = null;
      if (action.type === 'phone') {
        item = this.formBuilder.group({
          type: [WebhookIntegrationItemType.WHATSAPP_PHONE, Validators.required],
          label: ['Telefone Whatsapp'],
          message: ['Selecione o campo com o número de WhatsApp da lista de requisições à esquerda. O código do país (DDI - country code) deve ser inserido junto com o telefone. Caso o mesmo estiver em um campo separado, adicione ambos os campos. Se o DDI não estiver no campo do número, nem em um campo separado, por favor insira-o manualmente.'],
          value: [action.value, Validators.required],
          required: [true],
        });
      } else if (action.type === 'name') {
        item = this.formBuilder.group({
          type: [WebhookIntegrationItemType.CONTACT_NAME, Validators.required],
          label: ['Adicionar/Atualizar Nome do Contato'],
          message: ['Selecione o campo com o nome completo do contato da lista de requisições à esquerda. O contato será cadastrado em sua audiência caso o mesmo não esteja cadastrado. No caso do nome estar separado em dois campos, primeiro nome e sobrenome, adicione ambos os campos.'],
          value: [action.value, Validators.required],
          required: [true],
        });
      } else if (action.type === 'addTag') {
        item = this.formBuilder.group({
          type: [WebhookIntegrationItemType.ADD_TAG, Validators.required],
          label: ['Adicionar etiqueta'],
          message: ['Selecione a etiqueta que será adicionada ao contato após o mesmo ser cadastrado em sua audiência.'],
          value: [action.value, Validators.required],
          required: [false],
        });
      } else if (action.type === 'removeTag') {
        item = this.formBuilder.group({
          type: [WebhookIntegrationItemType.REMOVE_TAG, Validators.required],
          label: ['Remover etiqueta'],
          message: ['Selecione a etiqueta que será removida do contato. Caso o contato não possua a etiqueta, essa ação será ignorada e pulada.'],
          value: [action.value, Validators.required],
          required: [false],
        });
      } else if (action.type === 'attendance') {
        item = this.formBuilder.group({
          type: [WebhookIntegrationItemType.START_ATTENDANCE, Validators.required],
          label: ['Iniciar atendimento'],
          message: ['Selecione um departamento para dar início a um atendimento, você também pode selecionar um atendente específico, mas essa parte é opcional'],
          value: [action.value.department, Validators.required],
          attendent: [action.value.user],
          required: [false],
        });
      } else if (action.type === 'createOpportunity') {
        item = this.formBuilder.group({
          type: [WebhookIntegrationItemType.CREATE_OPPORTUNITY, Validators.required],
          label: ['Adicionar Oportunidade ao CRM'],
          message: ['Adicione uma nova oportunidade ao CRM sempre que essa ação for executada. Selecione o funil e a etapa que deseja adicionar a oportunidade criada'],
          funnel: [action.value.funnel, Validators.required],
          stage: [action.value.stage, Validators.required],
          priority: [action.value.priority],
          user: [action.value.user],
          product: [action.value.product],
          required: [false],
        });
      } else if (action.type === 'closeAttendance') {
        item = this.formBuilder.group({
          type: [WebhookIntegrationItemType.CLOSE_ATTENDANCE, Validators.required],
          label: ['Encerrar atendimento'],
          message: ['Encerrar o atendimento assim que essa ação for executada.'],
          required: [false],
        });
      } else if (action.type === 'addContactGroup') {
        item = this.formBuilder.group({
          type: [WebhookIntegrationItemType.ADD_CONTACT_GROUP, Validators.required],
          label: ['Adicionar contato no grupo'],
          message: ['Selecione o grupo que será adicionada ao contato após o mesmo ser cadastrado em sua audiência.'],
          value: [action.value, Validators.required],
          required: [false],
        });
      } else if (action.type === 'removeContactGroup') {
        item = this.formBuilder.group({
          type: [WebhookIntegrationItemType.REMOVE_CONTACT_GROUP, Validators.required],
          label: ['Remover contato no grupo'],
          message: ['Selecione o grupo que será removida do contato. Caso o contato não possua o grupo, essa ação será ignorada e pulada.'],
          value: [action.value, Validators.required],
          required: [false],
        });
      } else if (action.type === 'message') {
        if (action.typeMessage === 'template') {
          item = this.formBuilder.group({
            type: [WebhookIntegrationItemType.ADD_TEMPLATE, Validators.required],
            label: ['Template de mensagem'],
            message: ['Selecione o template de mensagem que você deseja enviar. Lembre-se que o template deve estar previamente aprovado.'],
            template: [action.template, Validators.required],
            templateParamsHeader: [action.templateParamsHeader],
            templateParamsBody: [action.templateParamsBody],
            templateParamsButton: [action.templateParamsButton],
            previewText: [action.previewText],
            required: [true],
          });
        } else {
          item = this.formBuilder.group({
            type: [WebhookIntegrationItemType.SEND_MESSAGE, Validators.required],
            label: ['Enviar mensagem'],
            message: [action.message || 'Você pode enviar diferentes tipos de mensagens com esta ação. Selecione o tipo de mensagem que você deseja enviar e adicione o conteúdo da mesma abaixo. Para Imagem, Áudio, Vídeo ou Documento por favor insira o link do arquivo do mesmo terminado com o tipo da extensão do arquivo. (Ex: "https://yourfilelink.com/file/image.jpg")'],
            typeMessage: [action.typeMessage, Validators.required],
            value: [action.value, Validators.required],
            caption: [action.caption],
            title: [action.title || ''],
            footer: [action.footer || ''],
            buttonActions: this.formBuilder.array(
              (action.buttonActions || []).map(btn => this.formBuilder.group({
                type: [btn.type, Validators.required],
                label: [btn.label, Validators.required],
                phone: [btn.phone],
                url: [btn.url],
              }))
            ),
            required: [false],
          });
          this.applyRcsShape(item, action);
        }
      } else if (action.type === 'triggerMessage') {
        item = this.formBuilder.group({
          type: [WebhookIntegrationItemType.ADD_TRIGGER_MESSAGE, Validators.required],
          label: ['Adicionar Gatilho de Mensagem'],
          message: ['Informe dados para disparar gatilhos do atendimento.'],
          typeMessage: [action.typeMessage, Validators.required],
          value: [action.value, Validators.required],
          caption: [action.caption || null],
          title: [action.title || ''],
          footer: [action.footer || ''],
          buttonActions: this.formBuilder.array(
            (action.buttonActions || []).map(btn => this.formBuilder.group({
              type: [btn.type, Validators.required],
              label: [btn.label, Validators.required],
              phone: [btn.phone],
              url: [btn.url],
            }))
          ),
          nameTriggerMessage: [action.nameTriggerMessage, Validators.required],
          keysTriggerMessage: [action.keysTriggerMessage, Validators.required],
          urlTriggerMessage: [action.urlTriggerMessage],
          id: [action.id],
          required: [false],
        });
        this.applyRcsShape(item, action);
      } else if (action.type === 'transferAttendance') {
        item = this.formBuilder.group({
          type: [WebhookIntegrationItemType.TRANSFER_ATTENDANCE, Validators.required],
          label: ['Transferir Atendimento'],
          message: ['Transferir o atendimento para outro atendente.'],
          department: [action.department, Validators.required],
          user: [action.user],
          required: [false],
        })
      } else if (action.type === 'createTracking') {
        item = this.formBuilder.group({
          type: [WebhookIntegrationItemType.CREATE_TRACKING, Validators.required],
          label: ['Adicionar Trackeamento'],
          message: ['Adicionar um trackeamento ao atendimento assim que essa ação for executada.'],
          required: [false],
        });
      } else if (action.type === 'originLead') {
        item = this.formBuilder.group({
          type: [WebhookIntegrationItemType.ORIGIN_LEAD, Validators.required],
          label: ['Adicionar Origem do Lead'],
          message: ['Adicionar origem do lead ao atendimento assim que essa ação for executada.'],
          originLead: [action.originLead, Validators.required],
          required: [false],
        });
      }
      if (item) {
        this.items.push(item);
      }
    });
    if (this.isActive) {
      this.formGroup.get('name').disable();
      this.formGroup.get('url').disable();
      this.formGroup.get('channel').disable();
      this.formGroup.get('company').disable();
      this.formGroup.get('webhook').disable();
      this.formGroup.get('tags').disable();
      this.formGroup.get('uuid').disable();
      this.formGroup.get('requestType').disable();
      this.items.controls.forEach(control => {
        control.disable();
      });
    } else {
      this.formGroup.get('name').enable();
      this.formGroup.get('url').enable();
      this.formGroup.get('channel').enable();
      this.formGroup.get('company').enable();
      this.formGroup.get('webhook').enable();
      this.formGroup.get('tags').enable();
      this.formGroup.get('uuid').enable();
      this.formGroup.get('requestType').enable();
      this.items.controls.forEach(control => {
        control.enable();
      });
    }
    this.ableDisableFields();
  }

  get items(): FormArray {
    return this.formGroup.get('items') as FormArray;
  }

  getItemForm(index: number): FormGroup {
    return this.items.at(index) as FormGroup;
  }

  private flattenObject(
    obj: Record<string, any>,
    parentKey = '',
    result: Record<string, any> = {}
  ): Record<string, any> {
    for (const key of Object.keys(obj)) {
      const newKey = parentKey ? `${parentKey}.${key}` : key;
      const value = obj[key];

      if (
        value &&
        typeof value === 'object' &&
        !Array.isArray(value)
      ) {
        this.flattenObject(value, newKey, result);
      } else if (Array.isArray(value)) {
        value.forEach((item, index) => {
          if (typeof item === 'object') {
            this.flattenObject(item, `${newKey}.${index}`, result);
          } else {
            result[`${newKey}.${index}`] = item;
          }
        });
      } else {
        result[newKey] = value;
      }
    }

    return result;
  }

  getWebhookRequests() {
    this.loading = true;
    const excludeParams = new Set(['code', 'uuid']);

    this.webhookIntegrationsService
      .getEventsByUUID(this.webhookIntegrations.uuid)
      .subscribe({
        next: (webhook: Array<Webhook>) => {
          webhook.forEach((webhook) => {
            const exist = this.webhooks.some((el) => el._id === webhook._id);
            if (!exist) {
              this.webhooks.push({
                _id: webhook._id,
                channel: webhook.channel,
                createdAt: webhook.createdAt,
                updatedAt: webhook.updatedAt,
                removed: webhook.removed,
                message: webhook.message,
                event: webhook.event,
                headers: webhook.headers,
                metadata: this.flattenObject({
                  ...webhook.metadata.query,
                  ...Object.fromEntries(
                    Object.entries(webhook.metadata.params).filter(
                      (e) => !excludeParams.has(e[0])
                    )
                  ),
                  ...webhook.metadata.body,
                }),
              });
            }
          });

          if (this.getParam('id')) {
            const webhookSelected = this.webhooks.find(
              (wb) =>
                wb._id === (this.webhookIntegrations.webhook as unknown as string)
            );
            if (webhookSelected) {
              this.webhookRequests = webhookSelected.metadata;
              this.formGroup.get('tags').patchValue(webhookSelected._id);
            }
          }
        },
        error: (err) => {
          console.error('Error fetching webhook requests:', err);
          this.alertService.error(this.t('integrations.webhookForm.errorFetchRequests'));
        },
        complete: () => {
          this.loading = false;
        },
      });
  }

  webhookRequestSelected(index) {
    this.webhookRequests = this.webhooks[index].metadata;
    this.webhookSelectedId = this.webhooks[index]._id;
    this.formGroup.get('webhook').setValue(this.webhooks[index]._id);
  }

  createActionTypeList() {
    this.actionsType = [];
    if (this.selectedChannel?.type === ChannelTypeEnum.CLOUD_API) {
      this.actionsType.push(WebhookIntegrationItemType.ADD_TAG);
      this.actionsType.push(WebhookIntegrationItemType.REMOVE_TAG);
      this.actionsType.push(WebhookIntegrationItemType.ADD_TEMPLATE);
      this.actionsType.push(WebhookIntegrationItemType.START_ATTENDANCE);
      this.actionsType.push(WebhookIntegrationItemType.TRANSFER_ATTENDANCE);
      this.actionsType.push(WebhookIntegrationItemType.CLOSE_ATTENDANCE);
      this.actionsType.push(WebhookIntegrationItemType.ADD_CONTACT_GROUP);
      this.actionsType.push(WebhookIntegrationItemType.REMOVE_CONTACT_GROUP);
      this.actionsType.push(WebhookIntegrationItemType.ADD_TRIGGER_MESSAGE);
      this.actionsType.push(WebhookIntegrationItemType.CREATE_OPPORTUNITY);
      this.actionsType.push(WebhookIntegrationItemType.CREATE_TRACKING);
      this.actionsType.push(WebhookIntegrationItemType.ORIGIN_LEAD);
    } else {
      this.actionsType.push(WebhookIntegrationItemType.ADD_TAG);
      this.actionsType.push(WebhookIntegrationItemType.REMOVE_TAG);
      this.actionsType.push(WebhookIntegrationItemType.SEND_MESSAGE);
      this.actionsType.push(WebhookIntegrationItemType.START_ATTENDANCE);
      this.actionsType.push(WebhookIntegrationItemType.TRANSFER_ATTENDANCE);
      this.actionsType.push(WebhookIntegrationItemType.CLOSE_ATTENDANCE);
      this.actionsType.push(WebhookIntegrationItemType.ADD_CONTACT_GROUP);
      this.actionsType.push(WebhookIntegrationItemType.REMOVE_CONTACT_GROUP);
      this.actionsType.push(WebhookIntegrationItemType.ADD_TRIGGER_MESSAGE);
      this.actionsType.push(WebhookIntegrationItemType.CREATE_OPPORTUNITY);
      this.actionsType.push(WebhookIntegrationItemType.CREATE_TRACKING);
      this.actionsType.push(WebhookIntegrationItemType.ORIGIN_LEAD);
    }
  }

  getActionTypeLabel(type: string): string {
    return WebhookIntegrationItemTypeTranslate[type];
  }

  addComponent(type: string): void {
    let item = null;
    if (type === WebhookIntegrationItemType.WHATSAPP_PHONE) {
      item = this.formBuilder.group({
        type: [WebhookIntegrationItemType.WHATSAPP_PHONE, Validators.required],
        label: ['Telefone Whatsapp'],
        message: ['Selecione o campo com o número de WhatsApp da lista de requisições à esquerda. O código do país (DDI - country code) deve ser inserido junto com o telefone. Caso o mesmo estiver em um campo separado, adicione ambos os campos. Se o DDI não estiver no campo do número, nem em um campo separado, por favor insira-o manualmente.'],
        value: ['', Validators.required],
        required: [true],
      });
    } else if (type === WebhookIntegrationItemType.CONTACT_NAME) {
      item = this.formBuilder.group({
        type: [WebhookIntegrationItemType.CONTACT_NAME, Validators.required],
        label: ['Adicionar/Atualizar Nome do Contato'],
        message: ['Selecione o campo com o nome completo do contato da lista de requisições à esquerda. O contato será cadastrado em sua audiência caso o mesmo não esteja cadastrado. No caso do nome estar separado em dois campos, primeiro nome e sobrenome, adicione ambos os campos.'],
        value: ['', Validators.required],
        required: [true],
      });
    } else if (type === WebhookIntegrationItemType.ADD_TAG) {
      item = this.formBuilder.group({
        type: [WebhookIntegrationItemType.ADD_TAG, Validators.required],
        label: ['Adicionar etiqueta'],
        message: ['Selecione a etiqueta que será adicionada ao contato após o mesmo ser cadastrado em sua audiência.'],
        value: [null, Validators.required],
        required: [false],
      });
    } else if (type === WebhookIntegrationItemType.REMOVE_TAG) {
      item = this.formBuilder.group({
        type: [WebhookIntegrationItemType.REMOVE_TAG, Validators.required],
        label: ['Remover etiqueta'],
        message: ['Selecione a etiqueta que será removida do contato. Caso o contato não possua a etiqueta, essa ação será ignorada e pulada.'],
        value: [null, Validators.required],
        required: [false],
      });
    } else if (type === WebhookIntegrationItemType.CREATE_OPPORTUNITY) {
      if (!this.items.controls.some((item) => item.get('type').value === WebhookIntegrationItemType.CREATE_OPPORTUNITY)) {
        item = this.formBuilder.group({
          type: [WebhookIntegrationItemType.CREATE_OPPORTUNITY, Validators.required],
          label: ['Adicionar Oportunidade ao CRM'],
          message: ['Adicione uma nova oportunidade ao CRM sempre que essa ação for executada. Selecione o funil e a etapa que deseja adicionar a oportunidade criada'],
          funnel: [null, Validators.required],
          stage: [null, Validators.required],
          priority: [null],
          user: [null],
          product: [null],
          required: [false],
        });
      }
    } else if (type === WebhookIntegrationItemType.START_ATTENDANCE) {
      if (!this.items.controls.some((item) => item.get('type').value === WebhookIntegrationItemType.START_ATTENDANCE)) {
        item = this.formBuilder.group({
          type: [WebhookIntegrationItemType.START_ATTENDANCE, Validators.required],
          label: ['Iniciar atendimento'],
          message: ['Selecione um departamento para dar início a um atendimento, você também pode selecionar um atendente específico, mas essa parte é opcional'],
          value: [null, Validators.required],
          attendent: [null],
          required: [false],
        });
      }
    } else if (type === WebhookIntegrationItemType.CLOSE_ATTENDANCE) {
      if (!this.items.controls.some((item) => item.get('type').value === WebhookIntegrationItemType.CLOSE_ATTENDANCE)) {
        item = this.formBuilder.group({
          type: [WebhookIntegrationItemType.CLOSE_ATTENDANCE, Validators.required],
          label: ['Encerrar atendimento'],
          message: ['Você pode encerrar o atendimento atual do contato. Caso o contato não possua um atendimento aberto, essa ação será ignorada.'],
          closeForced: [false],
          attendent: [null],
          required: [false],
        });
      }
    } else if (type === WebhookIntegrationItemType.SEND_MESSAGE) {
      item = this.formBuilder.group({
        type: [WebhookIntegrationItemType.SEND_MESSAGE, Validators.required],
        label: ['Enviar mensagem'],
        helpText: ['Você pode enviar diferentes tipos de mensagens com esta ação. Selecione o tipo de mensagem que você deseja enviar e adicione o conteúdo da mesma abaixo. Para Imagem, Áudio, Vídeo ou Documento por favor insira o link do arquivo do mesmo terminado com o tipo da extensão do arquivo. (Ex: "https://yourfilelink.com/file/image.jpg")'],
        typeMessage: [null, Validators.required],
        value: [null, Validators.required],
        caption: [null],
        title: [null],
        footer: [null],
        buttonActions: this.formBuilder.array([]),
        required: [false],
      });
      this.applyRcsShape(item);
    } else if (type === WebhookIntegrationItemType.ADD_TEMPLATE) {
      item = this.formBuilder.group({
        type: [WebhookIntegrationItemType.ADD_TEMPLATE, Validators.required],
        label: ['Template de mensagem'],
        helpText: ['Selecione o template de mensagem que você deseja enviar. Lembre-se que o template deve estar previamente aprovado.'],
        template: [null, Validators.required],
        templateParamsHeader: [null],
        templateParamsBody: [null],
        templateParamsButton: [null],
        previewText: [null],
        required: [true],
      });
    } else if (type === WebhookIntegrationItemType.ADD_CONTACT_GROUP) {
      item = this.formBuilder.group({
        type: [WebhookIntegrationItemType.ADD_CONTACT_GROUP, Validators.required],
        label: ['Adicionar contato no grupo'],
        message: ['Selecione o grupo que será adicionada ao contato após o mesmo ser cadastrado em sua audiência.'],
        value: [null, Validators.required],
        required: [false],
      });
    } else if (type === WebhookIntegrationItemType.REMOVE_CONTACT_GROUP) {
      item = this.formBuilder.group({
        type: [WebhookIntegrationItemType.REMOVE_CONTACT_GROUP, Validators.required],
        label: ['Remover contato no grupo'],
        message: ['Selecione a etiqueta que será removida do contato. Caso o contato não possua a etiqueta, essa ação será ignorada e pulada.'],
        value: [null, Validators.required],
        required: [false],
      });
    } else if (type === WebhookIntegrationItemType.ADD_TRIGGER_MESSAGE) {
      item = this.formBuilder.group({
        type: [WebhookIntegrationItemType.ADD_TRIGGER_MESSAGE, Validators.required],
        label: ['Adicionar Gatilho de Mensagem'],
        message: ['Selecione o gatilho que será adicionado ao contato.'],
        value: [null, Validators.required],
        nameTriggerMessage: [null, Validators.required],
        keysTriggerMessage: [null, Validators.required],
        urlTriggerMessage: [null],
        id: [uuidv4()],
        required: [false],
        typeMessage: [null, Validators.required],
        caption: [null],
        title: [null],
        footer: [null],
        buttonActions: this.formBuilder.array([]),
      });
      this.applyRcsShape(item);
    } else if (type === WebhookIntegrationItemType.TRANSFER_ATTENDANCE) {
      if (!this.items.controls.some((item) => item.get('type').value === WebhookIntegrationItemType.TRANSFER_ATTENDANCE)) {
        item = this.formBuilder.group({
          type: [WebhookIntegrationItemType.TRANSFER_ATTENDANCE, Validators.required],
          label: ['Transferir Atendimento'],
          message: ['Selecione um departamento para transferir o atendimento atual do contato.'],
          department: [null, Validators.required],
          user: [null],
          required: [false],
        })
      }
    } else if (type === WebhookIntegrationItemType.CREATE_TRACKING) {
      if (!this.items.controls.some((item) => item.get('type').value === WebhookIntegrationItemType.CREATE_TRACKING)) {
        item = this.formBuilder.group({
          type: [WebhookIntegrationItemType.CREATE_TRACKING, Validators.required],
          label: ['Adicionar Trackeamento'],
          message: ['Adicionar um trackeamento ao atendimento assim que essa ação for executada.'],
          required: [false],
        });
      }
    } else if (type === WebhookIntegrationItemType.ORIGIN_LEAD) {
      if (!this.items.controls.some((item) => item.get('type').value === WebhookIntegrationItemType.ORIGIN_LEAD)) {
        item = this.formBuilder.group({
          type: [WebhookIntegrationItemType.ORIGIN_LEAD, Validators.required],
          label: ['Adicionar Origem do Lead'],
          message: ['Adicionar uma origem ao lead assim que essa ação for executada.'],
          originLead: [null, Validators.required],
          required: [false],
        });
      }
    }
    if (item) {
      this.items.push(item);
    }
  }

  /**
   * The integration's channel is RCS. While an integration is being loaded `selectedChannel` is not
   * set yet, so the channel the integration was saved with answers.
   */
  isRcsChannel(): boolean {
    const channel = this.selectedChannel ?? (this.webhookIntegrations?.channel as Channel);
    return channel?.type === ChannelTypeEnum.RCS_API;
  }

  /**
   * On an RCS channel a message or trigger action is composed in the RCS editor
   * (SPEC-2026-10-rcs-webhook-integration-messages): the item gains the editor's group, hydrated from
   * the saved action — or from an action saved before the editor, converted — and the Z-API fields
   * it does not use stop being required.
   */
  private applyRcsShape(item: FormGroup, action?: { rcsData?: RCSData; typeMessage?: string; value?: unknown }): void {
    if (!this.isRcsChannel()) return;
    const rcsData = action?.rcsData ?? (action ? legacyActionToRcsData(action) : { type: RCSMessageTypeEnum.TEXT });
    item.addControl('rcsData', buildRcsDataGroup(rcsData));
    for (const field of ['typeMessage', 'value']) {
      item.get(field)?.clearValidators();
      item.get(field)?.updateValueAndValidity();
    }
  }

  /**
   * The message fields of an RCS action: the editor's content, plus the plain mirror an older
   * backend reads (`typeMessage` / `value`, plan AD-10). Read raw: an active integration's items are
   * disabled, and a disabled group drops out of `.value`.
   */
  private rcsActionFields(item: AbstractControl): { typeMessage: string; value: string; rcsData: RCSData } {
    const rcsData = item.get('rcsData').getRawValue() as RCSData;
    return { typeMessage: rcsMessageType(rcsData.type), value: rcsValueMirror(rcsData), rcsData };
  }

  public generateWebhookIntegrationsURLbyCode(uuid: string): string {
    const code = super.getCodeCompanyCurrentUser()
    return `${environment.trendIntegrationsUrl}/webhook/${code}/${uuid}`
  }

  deleteComponent(index: number): void {
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      width: '600px',
      data: this.t('integrations.webhookForm.confirmRemoveAction'),
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (Boolean(result) === true) {
        this.items.removeAt(index);
        this.alertService.success(this.t('integrations.webhookForm.successActionRemoved'));
      }
    });
  }

  ableDisableFields() {
    if (this.isActive) {
      this.formGroup.get('name').disable();
      this.formGroup.get('url').disable();
      this.formGroup.get('channel').disable();
      this.formGroup.get('company').disable();
      this.formGroup.get('webhook').disable();
      this.formGroup.get('tags')?.disable();
      this.formGroup.get('uuid').disable();
      this.formGroup.get('requestType').disable();
      this.formGroup.get('caption')?.disable();
      this.items.controls.forEach(control => {
        control.disable();
      });
    } else {
      this.formGroup.get('name').enable();
      this.formGroup.get('url').enable();
      this.formGroup.get('channel').enable();
      this.formGroup.get('company').enable();
      this.formGroup.get('webhook').enable();
      this.formGroup.get('tags')?.enable();
      this.formGroup.get('uuid').enable();
      this.formGroup.get('requestType').enable();
      this.formGroup.get('caption')?.enable();
      this.items.controls.forEach(control => {
        control.enable();
      });
    }
  }

  copyContent() {
    this.generateCurl();

    navigator.clipboard.writeText(this.curlContent).then(() => {
      this.alertService.info(this.t('integrations.webhookForm.infoCurlCopied'))
    }, (err) => {
      console.error('Erro ao copiar o conteúdo:', err);
    });
  }

  generateCurl() {
    const webhookUrl = this.formGroup.get('url')?.value;
    const action = this.webhookRequests;
    const payload: any = {
      type: action,
    };

    if (payload.type) {
      this.curlContent = `curl -X POST '${webhookUrl}' \\
      -H 'Content-Type: application/json' \\
      -d '${JSON.stringify(payload.type, null, 2)}'`;
    } else {
      this.curlContent = `curl -X POST '${webhookUrl}' \\
      -H 'Content-Type: application/json'`;
    }


    return this.curlContent;
  }

  openTestModal(): void {
    const dialogRef = this.dialog.open(WebhookTestModalComponent, {
      width: '800px',
      data: { 
        url: this.webhookIntegrations.url,
        webhookRequests: this.webhookRequests || null,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.getWebhookRequests();
      }
    });
  }

}
